<template>
  <div class="mt__main" style="background-color: #F7F8FA;">
    <div class>
      <el-carousel height="500px" style="width:100%;" arrow="never">
        <el-carousel-item>
          <div class="mt__banner mt__banner0"></div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="mt__banner mt__banner1"></div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="mt__banner mt__banner2"></div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="mt__center">
      <div class>
        <h1 style="margin-top:0;">公司介绍</h1>
        <span>名通科技，业内领先的信息技术服务提供商</span>
        <el-card shadow="hover" style="margin-top:60px;" :body-style="{ padding: '0px' }">
          <el-row>
            <el-col :span="12">
              <img src="../assets/index/company.png" class="mt__content--right">
            </el-col>
            <el-col :span="12" style="padding: 30px 40px 0 40px;">
              <h2 style="text-align: left;">Mastercom</h2>
              <p>深圳市名通科技股份有限公司成立于2006年，高新技术企业，深圳市重点软件企业。</p>
              <p>公司业务涵盖运营商、政府、金融、教育、电力等行业，公司客户遍布广东、北京、上海、山东、江苏、陕西、湖南、湖北、江西、广西等全国28省，是行业业务区域最广的企业之一。</p>
              <p>
                <router-link to="/about">
                  <div class="mt__button">查看详情</div>
                </router-link>
              </p>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </div>
    <div style="background-color: #FFFFFF;padding: 90px 0;">
      <div class="mt__center">
        <h1 style="margin-top: 0;">产品&技术</h1>
        <span>三大主营优势产品&通用技术能力</span>
        <div class="mt__content--table" style="margin: 60px 0 0;">
          <div class="mt__content--main">
            <div v-for="product in productsRow0" :key="product.id">
              <div style="margin: 0 auto;width: 256px;">
                <el-card shadow="hover" :body-style="{ padding: '30px' }">
                  <img width="140px" :src="product.img">
                  <div style="margin: 40px 0;">
                    <h2><strong style="color: #0084d0;">{{product.name}}</strong></h2>
                    <p>{{product.introduction}}</p>
                  </div>
                  <router-link :to="'/product#'+product.id">
                    <el-button type="primary" icon="el-icon-plus" size="small">了解更多</el-button>
                  </router-link>
                </el-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt__center">
      <div class>
        <h1 style="margin-top: 40px;">新闻资讯</h1>
        <div class="mt__content--table">
          <div class="mt__content--main">
            <div v-for="news in newsData" :key="news['标题']" @click="newsLink(news['详情链接'])">
              <el-card
                shadow="hover"
                style="width:367px;padding: 0px;"
                :body-style="{ padding: '0px' }"
                class="mt__news"
              >
                <div style="height:240px;overflow:hidden;">
                  <img :src="news['图片路径']" width="367">
                </div>
                <div style="padding: 20px;text-align: left;">
                  <h2 style="margin: 0;">{{ news['标题'] }}</h2>
                  <div style="height:66px;overflow:hidden;">
                    <p>{{ news['描述'] }}</p>
                  </div>
                  <span>{{ news['发布时间'] }}</span>
                </div>
              </el-card>
            </div>
          </div>
        </div>
        <router-link to="/news">
          <div class="mt__button">查看更多</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import newsImage from "../assets/index/news.png";
import productsInfos from "../assets/productInfos.js";

export default {
  name: "index",
  data() {
    return {
      productsRow0: [],
      productsRow1: [],
      productsRow2: [],
      newsData: []
    };
  },
  created() {},
  mounted() {
    this.$store.commit("activate", {
      activeName: "index"
    });

    this.productsRow0 = productsInfos.slice(0, 4);
    // this.productsRow1 = this.products.slice(4, 8);
    // this.productsRow2 = this.products.slice(8, 11);

    let that = this;
    this.$http
      .post("/mtex/mtplat/portal/queryNews")
      .then(function(response) {
        let newsData = response.data.result.data;
        for (let index = 0; index < 3; index++) {
          if (newsData[index]["图片路径"] == null) {
            newsData[index]["图片路径"] = newsImage;
          }
          if (newsData[index]["标题"].length > 15) {
            newsData[index]["标题"] =
              newsData[index]["标题"].slice(0, 15) + "...";
          }
          if (newsData[index]["描述"].length > 45) {
            newsData[index]["描述"] =
              newsData[index]["描述"].slice(0, 45) + "...";
          }
          that.newsData.push(newsData[index]);
        }
      })
      .catch(function(err) {
        console.log(err);
      });
  },
  updated() {},
  methods: {
    newsLink(url) {
      if (url) {
        window.open(url);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mt__banner {
  height: 100%;
}
.mt__banner0 {
  background-image: url("../assets/index/carousel0.png");
}
.mt__banner1 {
  background-image: url("../assets/index/carousel1.png");
}
.mt__banner2 {
  background-image: url("../assets/index/carousel2.png");
}

.mt__button {
  width: 120px;
  height: 36px;
  border-radius: 1px;
  border: 1px solid rgba(12, 143, 242, 1);
  display: inline-block;

  font-size: 14px;
  color: rgba(12, 143, 242, 1);
  line-height: 36px;
  text-align: center;
}
.mt__button:hover {
  background: rgba(12, 143, 242, 1);

  color: rgba(255, 255, 255, 1);
}
.mt__button:active {
  opacity: 0.8;
}

.mt__news {
  cursor: pointer;
}
.mt__news:hover img {
  animation: news 1s;
  animation-fill-mode: forwards;
}
@keyframes news {
  from {
    width: 367px;
  }
  to {
    width: 377px;
  }
}

h1 {
  margin-top: 60px;
}
span {
  color: #808080;
}
.mt__main {
  text-align: center;
}

.mt__content--table {
  margin: 60px 0;
}
.mt__content--main .el-card {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue